import { ReactNode } from 'react'

import { makeStyles } from '@material-ui/core/styles'

type MaxAppLayoutProps = {
  children: ReactNode
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--ds-bg-base, #f1f2f7)',
    fontFamily: "'Poppins', sans-serif",
    fontSize: 16,
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
  },
}))

const MaxAppLayout = ({ children }: MaxAppLayoutProps) => {
  const classes = useStyles()

  return (
    <div className={`${classes.root} max-app-root`}>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default MaxAppLayout
